
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"799ef8c4d3547d96009cc175fa8fb39693beaa40":"setRewardfulTokenAction","943fe08bea97ad5ce1b75b64056a7b14dbe59994":"$$ACTION_0"} */ export var setRewardfulTokenAction = createServerReference("799ef8c4d3547d96009cc175fa8fb39693beaa40");
import { createServerReference } from "private-next-rsc-action-client-wrapper";

